import { Link } from '@tanstack/react-router';
import { ExternalLink } from 'lucide-react';
import type { ReactNode } from 'react';
import { eventEntityLabel } from '@nest-recruit/shared';

// "Open application ↗" in the Event log's pane: a real link to the record's own screen, so Ctrl-click opens it in a
// new tab (06-qol §8). Kinds with no screen of their own (a session, a background job) get no link. The screen it
// opens applies its own permissions.

export function OpenRecordLink({ entityType, entityId, className }: { readonly entityType: string; readonly entityId: string; readonly className: string }): ReactNode {
  const label = (
    <>
      <ExternalLink size={14} aria-hidden />
      Open {eventEntityLabel(entityType).toLowerCase()}
    </>
  );
  switch (entityType) {
    case 'application':
      return <Link to="/applications/$applicationId" params={{ applicationId: entityId }} className={className}>{label}</Link>;
    case 'candidate':
      return <Link to="/candidates/$candidateId" params={{ candidateId: entityId }} className={className}>{label}</Link>;
    case 'job_opening':
      return <Link to="/jobs/$jobId" params={{ jobId: entityId }} className={className}>{label}</Link>;
    case 'requisition':
      return <Link to="/requisitions/$requisitionId" params={{ requisitionId: entityId }} className={className}>{label}</Link>;
    case 'interview':
      return <Link to="/interviews/$interviewId" params={{ interviewId: entityId }} className={className}>{label}</Link>;
    case 'offer':
      return <Link to="/offers/$offerId" params={{ offerId: entityId }} className={className}>{label}</Link>;
    case 'position':
      return <Link to="/organisation/positions/$positionId" params={{ positionId: entityId }} className={className}>{label}</Link>;
    case 'user':
      return <Link to="/admin/users/$userId" params={{ userId: entityId }} className={className}>{label}</Link>;
    case 'role':
      return <Link to="/admin/roles" search={{ role: entityId }} className={className}>{label}</Link>;
    case 'talent_pool':
      return <Link to="/pools/$poolId" params={{ poolId: entityId }} className={className}>{label}</Link>;
    case 'task':
      return <Link to="/tasks/$taskId" params={{ taskId: entityId }} className={className}>{label}</Link>;
    case 'assessment':
      return <Link to="/assessments/tests/$testId" params={{ testId: entityId }} className={className}>{label}</Link>;
    case 'exam_session':
      return <Link to="/assessments/sessions/$sessionId" params={{ sessionId: entityId }} className={className}>{label}</Link>;
    default:
      return null;
  }
}
